import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import {
  FaHome,
  FaRocket,
  FaTimes,
} from "react-icons/fa";
import { Capacitor } from "@capacitor/core";
import { useUser } from "../contexts/UserContext";
import "./AddToHomeScreenGuide.css";

const AddToHomeScreenGuide = () => {
  const [show, setShow] = useState(false);
  const { user } = useUser();

  useEffect(() => {
    const checkShouldShow = () => {
      if (!user) return;
      if (Capacitor.isNativePlatform()) return;

      const hasSeenGuide = localStorage.getItem(
        "starlaunch-homescreen-guide-seen"
      );
      if (hasSeenGuide) return;

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

      if (isIOS) {
        setTimeout(() => setShow(true), 1500);
      }
    };

    checkShouldShow();
  }, [user]);

  const handleDismiss = () => {
    // Mark as seen so it won't show again
    localStorage.setItem("starlaunch-homescreen-guide-seen", "true");
    setShow(false);
  };

  const handleNotNow = () => {
    // Just close without marking as permanently seen
    setShow(false);
  };

  if (!user) return null;

  return (
    <Modal
      show={show}
      onHide={handleNotNow}
      className="add-to-homescreen-modal"
      dialogClassName="bottom-modal"
      backdrop={true}
      keyboard={true}
    >
      <Modal.Header className="guide-header">
        <Modal.Title className="guide-title">
          <FaHome className="me-2" />
          Add to Home Screen
        </Modal.Title>
        <Button
          variant="link"
          onClick={handleNotNow}
          className="close-btn"
          aria-label="Close"
        >
          <FaTimes />
        </Button>
      </Modal.Header>

      <Modal.Body className="guide-body">
        <div className="intro-text">
          <p>Get quick access to Star Launch! 🚀</p>
        </div>

        <div className="steps-list">
          <div className="step-item">
            <span className="step-number">1</span>
            <span className="step-text">Use Safari browser</span>
          </div>

          <div className="step-item highlight-step">
            <span className="step-number">2</span>
            <span className="step-text">Tap the Share button below</span>
          </div>

          <div className="step-item">
            <span className="step-number">3</span>
            <span className="step-text">Select "Add to Home Screen"</span>
          </div>

          <div className="step-item">
            <span className="step-number">4</span>
            <span className="step-text">Tap "Add" to confirm</span>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer className="guide-footer">
        <div className="footer-actions">
          <Button
            variant="outline-light"
            onClick={handleNotNow}
            className="not-now-btn"
          >
            Not Now
          </Button>
          <Button
            variant="primary"
            onClick={handleDismiss}
            className="got-it-btn"
          >
            <FaRocket className="me-2" />
            Got It!
          </Button>
        </div>
      </Modal.Footer>

      <div className="share-button-pointer">
        <div className="pointer-caret">▼</div>
        <span className="pointer-text">Tap Share</span>
      </div>
    </Modal>
  );
};

export default AddToHomeScreenGuide;
